// extracted by mini-css-extract-plugin
var _1 = "textArea_error__n7KlF";
var _2 = "textArea_formTextArea__wM7jV";
var _3 = "textArea_formTextAreaLabel__RIKkb";
var _4 = "textArea_formTextAreaSpan__H2aKQ";
var _5 = "textArea_formTextAreaSpanError__B9ltl";
export { _1 as "error", _2 as "formTextArea", _3 as "formTextAreaLabel", _4 as "formTextAreaSpan", _5 as "formTextAreaSpanError" }
